// extracted by mini-css-extract-plugin
export default {"page":"QO","freeShippingContainer":"RO","customizeContainer":"SO","customizeHeader":"TO","fadein":"UO","customizeText":"VO","hidden":"WO","productcard":"XO","accordeonscontainer":"YO","freeShipping":"ZO","mainpart":"aP"};
    if(module.hot) {
      // 1713809678868
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  